/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Dob_Invalid_MonthInputs */

const en_clients_validation_dob_invalid_month = /** @type {(inputs: Clients_Validation_Dob_Invalid_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Month must be between 01 and 12.`)
};

const pt_br2_clients_validation_dob_invalid_month = /** @type {(inputs: Clients_Validation_Dob_Invalid_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O mês deve ser entre 01 e 12.`)
};

/**
* | output |
* | --- |
* | "Month must be between 01 and 12." |
*
* @param {Clients_Validation_Dob_Invalid_MonthInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_dob_invalid_month = /** @type {((inputs?: Clients_Validation_Dob_Invalid_MonthInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Dob_Invalid_MonthInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_dob_invalid_month(inputs)
	return pt_br2_clients_validation_dob_invalid_month(inputs)
});